import React from "react";

const SearchBar = React.memo(({ searchTerm, onSearchChange }) => {
  return (
    <div className="relative flex items-center">
      <label htmlFor="search" className="absolute right-6">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.2 14.2L17 17M16.2 8.6C16.2 4.40264 12.7974 1 8.6 1C4.40264 1 1 4.40264 1 8.6C1 12.7974 4.40264 16.2 8.6 16.2C12.7974 16.2 16.2 12.7974 16.2 8.6Z"
            stroke="#794AFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </label>
      <input
        placeholder="Search Blogs..."
        id="search"
        type="text"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="placeholder:text-paragraph w-full h-[65px] bg-transparent border border-purple/30 focus:border-purple focus:outline-none focus:right-0 rounded-[10px] px-[25px]"
      />
    </div>
  );
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;
